exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/user-reservation-check.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/user-reservation-check.component.scss
// module chunks = 0